const React = require("react");
const { useSyncee } = require("../context/SynceeContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const DropshippingOrders = () => {
  const { api, t } = useSyncee();
  const resource = useResource(() => api.getOrders({ page: 1, limit: 100 }), [api]);
  const [busy, setBusy] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const orders = resource.data?.orders || [];

  const run = async (order, action, success) => {
    setBusy(order._id); setMessage(""); setError("");
    try { await action(); setMessage(success); await resource.reload(); }
    catch (requestError) { setError(requestError.message); }
    finally { setBusy(""); }
  };

  const createOrder = (order) => {
    const orderId = order.orderId?._id || order.orderId;
    if (!orderId || !window.confirm(t("h_syncee_confirm_send_order", "Send this paid order to Syncee? Supplier charges may apply."))) return;
    run(order, () => api.createSupplierOrder(orderId, order.sellerId?._id || order.sellerId), t("h_syncee_order_sent", "Order sent to Syncee."));
  };

  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_syncee_orders_title", "Syncee orders"),
      description: t("h_syncee_orders_desc", "Orders are sent automatically when the partner API allows it; otherwise they remain ready for manual processing."),
      action: h(Button, { variant: "secondary", disabled: resource.loading || Boolean(busy), onClick: resource.reload }, t("h_syncee_refresh", "Refresh")),
    }),
    message ? h("div", { className: "synds-success", role: "status" }, message) : null,
    error ? h("div", { className: "synds-alert", role: "alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !orders.length, reload: resource.reload, t },
      h("div", { className: "synds-table-wrap" }, h("table", { className: "synds-table" },
        h("thead", null, h("tr", null,
          h("th", null, t("h_syncee_order", "Order")),
          h("th", null, t("h_syncee_status", "Status")),
          h("th", null, t("h_syncee_tracking", "Tracking")),
          h("th", null, t("h_syncee_error", "Error")),
          h("th", null, t("h_syncee_actions", "Actions"))
        )),
        h("tbody", null, ...orders.map((order) => {
          const manual = order.supplierStatus === "manual_action_required";
          const orderId = order.orderId?._id || order.orderId;
          return h("tr", { key: order._id },
            h("td", null, order.dropshippingOrderId || String(orderId || "").slice(-10) || "—"),
            h("td", null, h(StatusBadge, { status: order.supplierStatus || order.status, t })),
            h("td", null, order.trackingUrl ? h("a", { href: order.trackingUrl, target: "_blank", rel: "noopener noreferrer" }, order.trackingNumber || t("h_syncee_track", "Track")) : "—"),
            h("td", null, manual ? t("h_syncee_manual_order", "Complete this order from the connected Syncee account.") : order.errorSafeMessage || "—"),
            h("td", null, h("div", { className: "synds-row" },
              !manual && !order.supplierOrderId ? h(Button, { disabled: busy === order._id || !orderId, onClick: () => createOrder(order) }, order.errorSafeMessage ? t("h_syncee_retry_order", "Retry order") : t("h_syncee_send_order", "Send order")) : null,
              !manual && order.supplierOrderId ? h(Button, { variant: "secondary", disabled: busy === order._id, onClick: () => run(order, () => api.syncOrder(order._id), t("h_syncee_order_synced", "Order status updated.")) }, t("h_syncee_sync", "Sync")) : null,
              manual ? h("span", { className: "synds-muted" }, t("h_syncee_manual", "Manual")) : null
            ))
          );
        }))
      ))
    )
  );
};

module.exports = { DropshippingOrders };
